<template>

  <div :style="'height:667px;background-color:'+data.style.backgroundColor">
    <img :src="data.style.icon.indexOf('http')!=-1?data.style.icon:oss+data.style.icon" alt="" class="width100">
    <!-- <div class="p-13 fz-26 s_font_b s_bf" :style="'color:'+data.style.textColor">超级乐友汇</div> -->
    <div class="p-t-35 p-l-15 p-r-15 fz-16"  >
      <div class="s_flex_ali  " :style="'color:'+data.style.textColor">
        <span class="m-r-15">附近有</span><div class="number m-r-15" style="color:#131212">9</div><div class="number m-r-15" style="color:#131212">9</div><div class="number m-r-15" style="color:#131212"> 9</div><div class="number m-r-15" style="color:#131212">9</div> 人
      </div>
      <div class="m-b-6"  :style="'color:'+data.style.textColor">与您共同选择了</div>
      <div  :style="'color:'+data.style.textColor">百立乐®Natrapure</div>

    </div>
  <img src="@/assets/images/scan/customer_10000010/homback.png" alt="" class="width-115 height-62" style="position: absolute;
    right:14px;
    bottom: 100px;">
  </div>
</template>
<script>
import config from "@/config";
export default {
  props: { data: Object },
  components: {
  
  },
  setup(props) {
    const oss = config.oss[process.env.VUE_APP_type];
    return{
      oss
    }
  },
};
</script>
<style lang="less" scoped>
.number{
  width: 34px;
height: 46px;
background: linear-gradient(180deg, #FFFFFF 0%, #C6C6C5 49%, #FFFFFF 100%);
border: 1px solid #ECECEC;
text-align: center;
line-height: 46px;
font-size: 16px;
color: #131212;
}
</style>